export default __webpack_public_path__ + "static/media/file.5ad4c9d5.svg";